/* eslint-disable no-console */

import React, { useState } from 'react';
import { Box, Grid, Divider } from '@mui/material';
import { VeoliaButton } from '@veolia.com/vds-react-components';
import { get } from 'lodash';
import ClroButtonGrid from './clro-button-grid';
import CLRoFeedAnalysis from './clro-feed-analysis';
import { convertUnitValues } from '../../shared/conversion-helper/unitConversion';
import { decimalFormatter } from '../../shared/helper';
import { defaultModalOptions } from '../../shared/constantVariable';

const Clro = (props) => {
  const { handleCloseRoModal, dbTransactionDetails, updateElementParameters,
    roDetails, elementParameters, handleCloseRo, disabledStripperAndExplorerTab, setIsElementModelAccess,
    setElementParameters, setIsShowErrorMessage, translateObject } = props;
  const units = JSON.parse(localStorage.getItem('system-units'));
  const [strDescript, setStrDescript] = useState('');
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  // function to get element model on chnage
  const getnType = (curnType) => {
    const memDict = get(dbTransactionDetails, 'mem_dict', {});
    setStrDescript(memDict[curnType].strDescript);
  };
  const downLoadFlowSheetRo = (flowsheet_link) => {
    if (flowsheet_link) {
      window.open(`${flowsheet_link}`, '_blank', 'noreferrer');
    } else {
      setModalOption({ // show warning
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Spec File is not available for this Element.'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  };
  return (
    <Box className='clroMainCont'>
      <Grid item xs={12} className="ro-content-grid">
        <Grid container>
          <Grid item xs={12}>
            <CLRoFeedAnalysis
              handleCloseRoModal={handleCloseRoModal}
              dbTransactionDetails={dbTransactionDetails}
              roDetails={roDetails}
              elementParameters={elementParameters}
              updateElementParameters={updateElementParameters}
              handleCloseRo={handleCloseRo}
              setIsElementModelAccess={setIsElementModelAccess}
              setIsShowErrorMessage={setIsShowErrorMessage}
              getnType={getnType}
              setElementParameters={setElementParameters}
              disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
              translateObject={translateObject}
            />
          </Grid>
        </Grid>
      </Grid>
      {/* Button grid */}
      <Grid item xs={12} className='ro-footer-grid'>
        <Grid item xs={12} style={{ padding: '0 5px 5px 15px' }}>
          <ClroButtonGrid
            handleCloseRo={handleCloseRo}
            handleCloseRoModal={handleCloseRoModal}
            translateObject={translateObject}
          />
        </Grid>
        {/* ro Form footer */}
        <Divider style={{ 'margin': '0 1% 0 1.2%' }} />
        {/* new design update to CLRO page by chandrashekhar date 18-09-20204 START */}
        <Grid item xs={12} className='output-wrapper no_drag'>
          <div className='download-factsheet'>
            <div className='output-ro-machine'>
              <VeoliaButton
                htmlType="button"
                icon="picture_as_pdf"
                iconPosition="left"
                size="small"
                variant="secondary"
                disabled={!strDescript}
                onClick={() => downLoadFlowSheetRo(elementParameters.flowsheet_link)}
              >
                Download Factsheet
              </VeoliaButton>
            </div>
          </div>
          <div className='output-ro-machine-wrapper'>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Type')}: </span>
              <span className='S_Regular secoundary-text-color-Primary-default' style={{ display: 'inline-block', width: 115 }}> {strDescript}</span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Area')}</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {(units && units.flux === 'gfd') ?
                  Math.round(decimalFormatter(get(elementParameters, 'Area', 0) * 10.76, 2)) :
                  decimalFormatter(get(elementParameters, 'Area', 0), 2)}
                {(units && units.flux === 'gfd') ? <span>ft<sup>2</sup></span> : <span>m<sup>2</sup></span>}</span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Rejection')}</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {decimalFormatter(get(elementParameters, 'Nano(2)', 0), 2)} {' '} %
              </span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Nominal Flow')}</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {convertUnitValues(get(elementParameters, 'Nano(3)', 0), get(units, 'flow', 'Bbl/hr'))}
                {' '}
                {get(units, 'flow', 'Bbl/hr')}
              </span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Test TDS')}, mg/L</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {decimalFormatter(get(elementParameters, 'Nano(1)', 0), 0)}
                {' '}
                {get(elementParameters, 'Nano(x)', '')}
              </span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Test Pressure')}</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {convertUnitValues(get(elementParameters, 'Nano(0)', 0), get(units, 'pressure', 'atm'))}
                {' '}
                {get(units, 'pressure', 'atm')}
              </span>
            </div>
            <div className='output-ro-machine'>
              <span className='mr10 output-feed'>{translateObject('Max Pressure')}</span>
              <span className='S_Regular secoundary-text-color-Primary-default'>
                {convertUnitValues(get(elementParameters, 'Nano(4)', 0), get(units, 'pressure', 'atm'))}
                {' '}
                {get(units, 'pressure', 'atm')}
              </span>
            </div>
          </div>
        </Grid>
        {/* new design update to CLRO page by chandrashekhar date 18-09-20204 END */}
        {/* Hide in CLRO page 'Type Area etc...' Old Design replace to new design Start GB-2543 START */}
        <div className='footer-title sansW4SeLig' style={{ display: 'none' }}>
          <span className='no_drag S_Regular'>{translateObject('Type')} :</span>
          <pre style={{ 'color': '#00AEC7', 'fontFamily': 'arial' }} className='no_drag'>  {strDescript}
          </pre>
        </div>
        <Grid container style={{ 'marginTop': '0px', display: 'none' }}>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Area')}</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {/* checking the sysytem unit and if unit of flux is gfd then round off the value to whole number else don't round off */}
                  {(units && units.flux === 'gfd') ?
                    Math.round(decimalFormatter(get(elementParameters, 'Area', 0) * 10.76, 2)) :
                    decimalFormatter(get(elementParameters, 'Area', 0), 2)}
                  {' '}
                  {/* checking the sysytem unit and if unit of flus is gfd then visible unit will be ft2 else m2 */}
                  {(units && units.flux === 'gfd') ? <span>ft<sup>2</sup></span> : <span>m<sup>2</sup></span>}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Rejection')}</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {decimalFormatter(get(elementParameters, 'Nano(2)', 0), 2)}
                  {' '}
                  %
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Nominal Flow')}</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {convertUnitValues(get(elementParameters, 'Nano(3)', 0), get(units, 'flow', 'Bbl/hr'))}
                  {' '}
                  {get(units, 'flow', 'Bbl/hr')}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-top-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Test TDS')}, mg/L</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {decimalFormatter(get(elementParameters, 'Nano(1)', 0), 0)}
                  {' '}
                  {get(elementParameters, 'Nano(x)', '')}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-top-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Test Pressure')}</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {convertUnitValues(get(elementParameters, 'Nano(0)', 0), get(units, 'pressure', 'atm'))}
                  {' '}
                  {get(units, 'pressure', 'atm')}
                </span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4} className='pd-top-left'>
            <Grid container style={{ 'justifyContent': 'center' }}>
              <Grid item xs={6}>
                <span className='no_drag S_Regular'>{translateObject('Max Pressure')}</span>
              </Grid>
              <Grid item xs={4}>
                <span className='no_drag S_Regular' style={{ color: '#00AEC7' }}>
                  {convertUnitValues(get(elementParameters, 'Nano(4)', 0), get(units, 'pressure', 'atm'))}
                  {' '}
                  {get(units, 'pressure', 'atm')}
                </span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* Hide in CLRO page 'Type Area etc...' Old Design replace to new design Start GB-2543 END */}
      </Grid>
    </Box>
  );
};

export default Clro;